import { render } from "./App.vue?vue&type=template&id=06e8071f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=06e8071f&lang=scss"
script.render = render

export default script